import React from 'react';
import { NumericFormat } from 'react-number-format';
import { FindLoad, formatNumberToFix } from 'utils';
import { Skeleton } from '@mui/material';

export const BillingTotalBox = ({ title, total, actionType, list }) => {
    const loader = FindLoad(actionType);

    if (loader?.length) {
        return (
            <div style={{ marginBottom: '-6px' }}>
                <Skeleton variant="rectangular" width={'100%'} height={66} style={{ borderRadius: '8px 8px 0px 0px' }} />
            </div>
        );
    }

    return (
        <div className="billing-total-box" style={{ gap: 12 }}>
            {list?.length ? (
                list.map((item, index) => (
                    <div key={index} className="billing-total-row">
                        <p className="billing-total-title">{item?.title}</p>
                        <div className="billing-total-price-row">
                            <NumericFormat
                                // value={item?.value ? item?.value.toFixed(3) : 0}
                                value={item?.value ? formatNumberToFix(item?.value) : 0}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'$'}
                            />
                        </div>
                    </div>
                ))
            ) : (
                <div className="billing-total-row">
                    <p className="billing-total-title">{title}</p>
                    <div className="billing-total-price-row">
                        <NumericFormat
                            // value={total ? total.toFixed(3) : 0}
                            value={total ? formatNumberToFix(total) : 0}
                            displayType={'text'}
                            thousandSeparator={true}
                            prefix={'$'}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};
